import { jsx as _jsx } from "react/jsx-runtime";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import styles from "./ReferralPersonalCode.module.scss";
export const ReferralPersonalCodeIcon = ({ img, url, trackingName }) => {
    const dispatchGTMEvent = () => {
        dispatchTrackingEvent(TrackingEvents.TrackingSocialIconClick, { social_network: trackingName });
    };
    return (_jsx("a", { className: styles.icon, "data-testid": "referral-personal-code-icon", href: url, target: "_blank", onClick: dispatchGTMEvent, rel: "noreferrer", children: _jsx("img", { src: img, alt: "not found" }) }));
};
//# sourceMappingURL=ReferralPersonalCodeIcon.js.map